import { Button } from '@/components/ui/button';
import { useAppRegion } from '@/hooks/dataHelpers/useCurrentUser';
import {
  getLegacyMacDownloadUrl,
  LEGACY_MAC_BUILDS,
  type LegacyMacGrants,
} from '@/lib/offline/OfflineAppHelper';
import { DownloadLinear } from '@assessprep/icons/solar';
import { useTranslate } from '@refinedev/core';
import {
  instructionsHeadingClass,
  instructionsListClass,
  sectionClass,
  supportedVersionsClass,
} from './sectionStyles';

/**
 * Student-only legacy Mac builds, one tile per granted accommodation. Each
 * tile states the macOS range the build runs on, so the student picks the one
 * their Mac can install.
 */
export const LegacyMacTab = ({ accommodations }: { accommodations: LegacyMacGrants }) => {
  const translate = useTranslate();
  const appRegion = useAppRegion();

  return (
    <div className="space-y-6">
      {LEGACY_MAC_BUILDS.filter((build) => accommodations[build.accommodationKey]).map((build) => (
        <div className={sectionClass} key={build.version}>
          <Button asChild data-testid={build.testId}>
            <a href={getLegacyMacDownloadUrl(build, appRegion)}>
              <DownloadLinear aria-hidden />
              {translate('OfflineApp.download_assessprep_mac_v_version', {
                version: build.version,
              })}
            </a>
          </Button>
          <p className={supportedVersionsClass}>{translate(build.supportedVersionsKey)}</p>
        </div>
      ))}
      <div className={sectionClass}>
        <h3 className={instructionsHeadingClass}>
          {translate('OfflineApp.instructions_to_install_the_app_on_mac')}
        </h3>
        <ol className={instructionsListClass}>
          <li>{translate('OfflineApp.you_can_take_a_test_by_using_our_assessprep_app')}</li>
          <li>{translate('OfflineApp.double_click_on_the_downloaded_dmg_file_and_follow_the')}</li>
        </ol>
      </div>
    </div>
  );
};
